import { GlobalController } from 'src/shared/global/GlobalController'
import AnnualWeighing from './AnnualWeighing.vue'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: ':link',
    name: 'annualWeighing',
    component: AnnualWeighing,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
